import { MatItem } from "@/components/Mat";
import { H4 } from "@/components/Typography";

interface IProps {
  section: IMatIntegrationConfigurationSection;
}

const MatSection = ({ section }: IProps) => {
  const { title, items, channel } = section;

  const renderItems = () =>
    items?.map((item, index) => (
      <MatItem key={index} channel={channel} item={item} />
    ));

  return (
    <div id={`${title}-section`} className="mb-40">
      <H4 className="mb-10 font-semibold">{title}</H4>
      <hr className="mb-30" />
      {renderItems()}
    </div>
  );
};

export default MatSection;
